import {useEffect, useState} from 'react';
import {
  ICourseUnitFragmentFragment,
  useCourseUnitByEndUrlLazyQuery,
} from '~Api/Graphql/gql/types.generated';

import {useCurrentLanguage} from '@src/Store/Slices/LanguageSlice/Language.selector';
import apiConfig from '@src/Configs/apiConfig';

interface UseFetchCourseUnitProps {
  endUrl: string;
}

interface UseFetchCourseUnitResult {
  data?: ICourseUnitFragmentFragment;
  courseUnitUrls?: string[];
  courseId?: string;
  courseUrl?: string;
  unitId?: string;
  loading: boolean;
  umbracoData?: any; // Données Umbraco brutes pour extraction locale
}

const useFetchCourseUnit = ({
  endUrl,
}: UseFetchCourseUnitProps): UseFetchCourseUnitResult => {
  const [fetchCourseUnit, {data, loading}] = useCourseUnitByEndUrlLazyQuery();
  const [umbracoData, setUmbracoData] = useState<any>(null);
  const currentLanguage = useCurrentLanguage();
  const umbProjectAlias = apiConfig.umbProjectAlias;

  useEffect(() => {
    if (endUrl) {
      fetchCourseUnit({variables: {endUrl}});
    }
  }, [endUrl]);

  // Fetch Umbraco data brutes du CourseUnit
  useEffect(() => {
    const unitId = data?.allCourseUnit?.items[0]?.id;
    if (!unitId) return;

    const fetchFromUmbraco = async () => {
      try {
        const response = await fetch(
          `https://cdn.umbraco.io/content/${unitId}?culture=${currentLanguage}`,
          {
            headers: {
              'Umb-Project-Alias': umbProjectAlias,
              'Accept-Language': currentLanguage,
            },
          },
        );
        const umbracoItem = await response.json();
        setUmbracoData(umbracoItem);
      } catch (error) {
        console.error('Error fetching from Umbraco REST API:', error);
      }
    };

    fetchFromUmbraco();
  }, [data, currentLanguage, umbProjectAlias]);

  const courseUnit = data?.allCourseUnit?.items[0];
  const courseId =
    courseUnit?.parent?.__typename === 'Course' ? courseUnit?.parent?.id : '';
  const courseUrl =
    courseUnit?.parent?.__typename === 'Course' ? courseUnit?.parent?.url : '';
  const courseUnitUrls: string[] = [];

  if (courseUnit?.parent?.__typename === 'Course') {
    courseUnit?.parent?.children?.items?.forEach(child => {
      if (child?.__typename === 'CourseUnit') {
        courseUnitUrls.push(child?.url || '');
      }
    });
  }

  return {
    data: courseUnit,
    unitId: courseUnit?.id,
    courseUnitUrls,
    courseId,
    loading,
    courseUrl,
    umbracoData,
  };
};

export default useFetchCourseUnit;
